import { Portal } from 'api/organization/onboardingTypes';

export const getPortalDescription = (portal: Portal): string => {
  switch (portal) {
    case Portal.Riayati:
      return 'The national unified medical records platform in the UAE';
    case Portal.Shafafiya:
      return 'The health insurance claims platform used in Abu Dhabi';
    case Portal.eClaimLink:
      return 'Dubai Health Authority electronic insurance claims platform';
    default:
      throw new Error(`Unknown portal: ${portal}`);
  }
};
